import toast from "react-hot-toast";

export const copyTextToClipboard = (text, label = "Copied") => {
  const s = (text || "").toString().trim();
  if (!s) {
    toast.error("Nothing to copy");
    return;
  }
  navigator.clipboard.writeText(s).then(
    () => toast.success(label),
    () => toast.error("Failed to copy"),
  );
};

// Spreadsheet TSV: a cell is quoted only when it starts with ", so quotes inside text stay as typed.
const parseTSV = (text) => {
  const rows = [];
  let row = [];
  let cell = "";
  let inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"' && text[i + 1] === '"') {
        cell += '"';
        i++;
      } else if (ch === '"') {
        inQuotes = false;
      } else {
        cell += ch;
      }
    } else if (ch === '"' && cell === "") {
      inQuotes = true;
    } else if (ch === "\t") {
      row.push(cell);
      cell = "";
    } else if (ch === "\n" || ch === "\r") {
      if (ch === "\r" && text[i + 1] === "\n") i++;
      row.push(cell);
      rows.push(row);
      row = [];
      cell = "";
    } else {
      cell += ch;
    }
  }
  if (cell || row.length) {
    row.push(cell);
    rows.push(row);
  }
  if (rows.length && rows[rows.length - 1].every((c) => c === "")) rows.pop();
  return rows;
};

/** Grid for a paste copied from a sheet (HTML table or tabs); null for plain text, which the cell pastes as is. */
export const clipboardGrid = (clipboardData) => {
  const text = clipboardData?.getData("text/plain");
  if (!text) return null;
  const html = clipboardData.getData("text/html") || "";
  if (!/<table/i.test(html) && !text.includes("\t")) return null;
  const grid = parseTSV(text);
  return grid.length > 1 || grid[0]?.length > 1 ? grid : null;
};
